const estilo_coluna_fixo = {
  backgroundColor: 'white',
  position: 'sticky !important',
  zIndex: '1 !important',
}

export const cabecalhos = [
  {
    text: '',
    value: 'data-table-select',
    arrastavel: false,
    style: {
      width: '5px'
    }
  },
  {
    text: '',
    value: 'nivel_servico',
    arrastavel: false,
    ativa: true,
    fixa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Grupo',
    value: 'grupo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Código',
    value: 'idcategoria',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Categoria',
    value: 'descricao_categoria',
    arrastavel: false,
    ativa: true,
    fixa: true,
    sortable: false,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Projeção de vendas (UND)',
    value: 'cmm_pa',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Projeção de vendas (PESO)',
    value: 'cmm_peso',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque pa (UN)',
    value: 'estoque_pa',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque pa (PESO)',
    value: 'estoque_pa_peso',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque mp (PESO)',
    value: 'estoque_mp_peso',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque geral (PESO)',
    value: 'estoque_peso',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Cobertura geral',
    value: 'cobertura_geral_dias',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Última entrada',
    value: 'ultima_entrada',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '110px'
    }
  },
  {
    text: 'Última venda',
    value: 'ultima_venda',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '95px'
    }
  },
  {
    text: 'Pedido pendente',
    value: 'estoque_transito_peso',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Prazo médio de recebimento',
    value: 'prazo_medio_recebimento',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Cobertura estoque Futura',
    value: 'cobertura_estoque_futura',
    arrastavel: true,
    ativa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Sugestão de compra',
    value: 'quantidade_sugerida',
    arrastavel: false,
    ativa: true,
    fixa: true,
    sortable: false,
    styleHeader: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Preço de custo',
    value: 'preco_custo',
    arrastavel: false,
    ativa: true,
    fixa: true,
    sortable: false,
    opcional: true,
    style: {
      ...estilo_coluna_fixo,
      minWidth: '130px',
      maxWidth: '130px',
      right: '190px',
      left: 'auto',
      paddingLeft: '11px',
      border: 0,
      borderLeft: '2px solid rgba(0,0,0,.1)',
    },
  },
  {
    text: 'Total R$',
    value: 'sugestao_compra_preco_custo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '115px',
    }
  },
  {
    text: 'Quantidade',
    value: 'quantidade',
    arrastavel: false,
    ativa: true,
    fixa: true,
    sortable: false,
    style: {
      ...estilo_coluna_fixo,
      minWidth: '190px',
      maxWidth: '190px',
      right: 0,
      left: 'auto',
      paddingLeft: '11px',
      border: 0,
      borderLeft: '2px solid rgba(0,0,0,.1)',
    },
  },
];
